// External Libraries
import { Button } from "primereact/button";

// Local Components
import { LoginLayout } from "../LoginLayout/LoginLayout";

// Hooks & Helpers
import { signOut } from "sj-ui-toolkit/src/utils";

// Main component
export default function NoLicenseAvailable() {
  return (
    <LoginLayout
      noFooter={true}
      title="No License Available"
      titleClassName="atlas-h4 p-4 pb-0 text-center"
    >
      <div className="flex flex-col w-full gap-2">
        <div className="text-center">
          <p className="mb-4">
            You are not currently licensed. Please get in touch with your administrator to access
            Security Journey.
          </p>
          <Button className="w-full mt-3" onClick={() => signOut()} label="Back to Login" />
        </div>
      </div>
    </LoginLayout>
  );
}
